// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

BCSfFilter.prototype.buildSuggestion = function(searchTerm, suggestionData, ul, searchBoxId) {
  var self = this,
    searchTerm = this.escape(searchTerm),
    ulSelector = jQ(ul),
    result = '',
    isAllEmpty = getValueInObjectArray('all_empty', suggestionData);
  // Show suggestion wrapper
  ulSelector.closest('.' + self.class.searchSuggestionWrapper).show();
  // Check is_empty
  // If true: Nothing found
  if (isAllEmpty) {
    var hasRedirect = getValueInObjectArray('redirect', suggestionData);
    // If have search redirect and no result, hide the search suggestion
    if (hasRedirect) {
      ulSelector.closest('.' + self.class.searchSuggestionWrapper).hide();
      // Otherwise build no result block
    } else {
      result += self.buildSuggestionNoResult(searchTerm, ul);
      ulSelector.append(result);
    }
  }
  // Otherwise: Start buidling the content of Suggestion
  else {
    // Build main content
    var blocks = self.getSettingValue('search.suggestionBlocks');
    // Update the label of suggestion blocks by translation label
    blocks = this.updateSuggestionBlockLabel(blocks);
    // Style2
    if (self.isSuggestionStyle2() && blocks[0].type != "products") {
      var indexProducts = blocks.findIndex(function(block) {
        return block.type == 'products';
      });
      var tempProducts = blocks[indexProducts];
      blocks.splice(indexProducts, 1);
      // if suggestionStyle2ReverseProductBlock is enabled
      if (self.getSettingValue('search.suggestionStyle2ReverseProductBlock')) {
        blocks.push(tempProducts);
      } else {
        blocks.unshift(tempProducts);
      }
    }
    var blocksLength = blocks.length;
    var k;
    for (k = 0; k < blocksLength; k++) {
      var suggestionItemInfo = blocks[k];
      if (suggestionItemInfo.hasOwnProperty('status') && suggestionItemInfo['status'] == 'active') {
        var index = self.findIndexArray(suggestionItemInfo['type'], suggestionData, 'key');
        if (index > -1 && suggestionData[index].hasOwnProperty('values')) {
          var suggestionItemData = suggestionData[index];
          var content = '<li class="bc-sf-search-suggestion-group" data-group="' + suggestionItemInfo['type'] + '" aria-label="' + blocks[k]['label'] + '"><ul>';
          switch (suggestionItemInfo['type']) {
            case 'suggestions':
              content += self.buildSuggestionPopular(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
              break;
            case 'products':
              content += self.buildSuggestionProductList(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
              break;
            case 'pages':
              content += self.buildSuggestionPage(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
              break;
            case 'collections':
              content += self.buildSuggestionCollection(searchTerm, suggestionItemData['values'], ul, suggestionItemInfo, suggestionData);
              break;
          }
          content += '</ul></li>';
          ulSelector.append(content);
        }
      }
    }
    // Build 'View All'
    if (getValueInObjectArray('suggest_query', suggestionData) === '') {
      var viewAllContent = self.buildSuggestionViewAll(searchTerm, suggestionData, ul);
      ulSelector.append(viewAllContent);
    }
  }
  // Add autocomplete item data for navigation
  ulSelector.find('.' + self.class.searchSuggestionItem + '[data-label]').each(function() {
    var $this = jQ(this);
    var label = $this.data('label') || '';
    var value = $this.data('value') || '';
    if (value !== '') {
      $this.data('ui-autocomplete-item', { label: label.toString(), value: value }).addClass('bc-ui-item');
    }
  });
  // Wrapper
  self.buildSuggestionWrapper(ul, searchBoxId);
};

// Build Popular Suggestions
BCSfFilter.prototype.buildSuggestionPopular = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    if (Object.keys(itemData).length > 0) {
        // Build content
        var result = this.buildSuggestionHeader(itemInfo['label'], 'popular');
        var itemDataLength = itemData.length;
        var k;
        for (k = 0; k < itemDataLength; k++) {
            // if (k < itemInfo['number']) {
                var searchResult = this.highlightSuggestionResult(itemData[k], searchTerm);
                result += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]) + '" data-value="' + this.escape(itemData[k]) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]) + '">';
                result += '<a href="' + this.buildSearchLink(itemData[k]) + '">' + searchResult + '</a>';
                result += '</li>';
            // }
        }
    }
    return result;
};

// Build Pages
BCSfFilter.prototype.buildSuggestionPage = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    if (Object.keys(itemData).length > 0) {
        // Build content
        var result = this.buildSuggestionHeader(itemInfo['label'], 'page');
        var k;
        var itemDataLength = itemData.length;
      	var currentLocale = '';
      	if (bcSfFilterMainConfig.general.current_locale && !bcSfFilterMainConfig.general.published_locales[bcSfFilterMainConfig.general.current_locale.toLowerCase()]) currentLocale = '/' + bcSfFilterMainConfig.general.current_locale.toLowerCase();
        for (k = 0; k < itemDataLength; k++) {
            // if (k < itemInfo['number']) {
                var searchResult = this.highlightSuggestionResult(itemData[k]['title'], searchTerm);
                result += '<li class="' + this.class.searchSuggestionItem + '" data-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '" data-value="' + this.escape(itemData[k]['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
                result += '<a href="' + currentLocale + itemData[k]['url'] + '">' + searchResult + '</a>';
                result += '</li>';
            // }
        }
    }
    return result;
}


BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var self = this;
    var result = '';
    // Buid Header
    result += this.buildSuggestionHeader(itemInfo['label'], 'product');
    // Build Did you mean
    var dym = this.buildSuggestionDidYouMean(searchTerm, suggestionData, ul);
    if (dym != '') {
        result += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + dym + '</li>';
    }
    // Build content
    if (Object.keys(itemData).length > 0) {
        // var count = 0;   
        var k;
        var itemDataLength = itemData.length; 
        for (k = 0; k < itemDataLength; k++) {
            // if (count < itemInfo['number']) {
            var product = itemData[k];
            // Get product attributes
            var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, itemData);
            productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
            var productUrl = this.buildProductItemUrl(product, false);
            var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][1]['src'], '200x') : bcSfFilterConfig.general.no_image_url;
            // Get custom class / attribute
            var searchSuggestionClass = this.class.searchSuggestion;
            var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
            result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" data-label="' + this.escape(product['id']) + '" data-value="' + this.escape(product['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(product['title']) + '">';
            result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
            // Build Left column
            if (this.getSettingValue('search.showSuggestionProductImage')) {
                result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
            }
            // Build Right column
            result += '<div class="' + searchSuggestionClass + '-right">';
            result += '<div class="' + searchSuggestionClass + '-product-title">' + productTitle + '</div>';

             // Add Price
            // var prevPrice = product.compare_at_price_min;
            // result += '<div class="product-card__prices">';
            // // Add previous price if it has
            // if(prevPrice) {
            //     var currency = this.formatMoney(prevPrice).substr(0, 1); // Couldn't find a better way, data didn't provide the store currency
            //     var priceAmount = prevPrice.toString().split('.')[0];
            //     var priceAmountAfterSeparator = prevPrice.toString().split('.')[1] || '00';
            //     var priceSeparator = '.' // Taken from Shopify settings

            //     result += '<div class="product-card__price product-card__price--prev">' +
            //                             '<span class="product-card__price__currency">' + currency + '</span>' +
            //                             '<span class="product-card__price__amount">' + priceAmount + '</span>' +
            //                             '<span class="product-card__price__separator">' + priceSeparator + '</span>' +
            //                             '<span class="product-card__price__after-comma">' + priceAmountAfterSeparator + '</span>' +
            //                         '</div>';
            // }

            // // Add current price
            // var currency = this.formatMoney(product.price_min).substr(0, 1); // Couldn't find a better way, data didn't provide the store currency
            // var priceAmount = product.price_min.toString().split('.')[0];
            // var priceAmountAfterSeparator = product.price_min.toString().split('.')[1] || '00';
            // var priceSeparator = '.' // Taken from Shopify settings

            // result += '<div class="product-card__price">' +
            //                         '<span class="product-card__price__currency">' + currency + '</span>' +
            //                         '<span class="product-card__price__amount">' + priceAmount + '</span>' +
            //                         '<span class="product-card__price__separator">' + priceSeparator + '</span>' +
            //                         '<span class="product-card__price__after-comma">' + priceAmountAfterSeparator + '</span>' +
            //                     '</div>';

            // result += '</div>';

            result += '</div>'; // End Right column
            result += '</a>'; // End a
            result += '</li>'; // End li
            // count++;
            // } else break;
        }
    }
    return result;
};

// Build Collections
BCSfFilter.prototype.buildSuggestionCollection = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    if (Object.keys(itemData).length > 0) {
        // Build content
        var result = bcsffilter.buildSuggestionHeader(itemInfo['label'], 'collection');
        var k;
        var itemDataLength = itemData.length;
      	var currentLocale = '';
      	if (bcSfFilterMainConfig.general.current_locale && !bcSfFilterMainConfig.general.published_locales[bcSfFilterMainConfig.general.current_locale.toLowerCase()]) currentLocale = '/' + bcSfFilterMainConfig.general.current_locale.toLowerCase();
        for (k = 0; k < itemDataLength; k++) {
            // if (k < itemInfo['number']) {
                var searchResult = bcsffilter.highlightSuggestionResult(itemData[k]['title'], searchTerm);
                result += '<li class="' + bcsffilter.class.searchSuggestionItem + '" data-label="' + this.escape(itemData[k]['id']) + '" data-value="' + this.escape(itemData[k]['title']) + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
                result += '<a href="' + currentLocale + '/collections/' + itemData[k]['handle'] + '">' + searchResult + '</a>';
                result += '</li>';
            // }
        }
    }
    return result;
}
// Build Did you mean
BCSfFilter.prototype.buildSuggestionDidYouMean = function(searchTerm, suggestionData, ul) {
    var result = '';
    if (typeof suggestionData !== 'undefined' && Object.keys(suggestionData).length > 0) {
        var suggestQuery = getValueInObjectArray('suggest_query', suggestionData);
        // Get total products
        var totalProduct = getValueInObjectArray('total_product', suggestionData);
        var prevTotalProduct = getValueInObjectArray('prev_total_product', suggestionData);
        if (prevTotalProduct !== '' && totalProduct > 0) totalProduct = prevTotalProduct;
        // Build Did you mean list
        var dymList = getValueInObjectArray('did_you_mean', suggestionData);
        var dym = '';
        if (dymList != '' && dymList.length > 0) {
            var k;
            var dymListLength = dymList.length;
            for (k = 0; k < dymListLength; k++) {
                dym += '<a href="' + this.buildSearchLink(dymList[k]) + '">' + dymList[k] + '</a>';
                if (k < dymList.length - 1) dym += '<span>,</span> ';
            }
        }
        // Build content
        if (suggestQuery != searchTerm) {
            if (totalProduct == 0) result += '<p>' + this.getSettingValue('label.error.noSuggestionProducts').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>') + '</p>';
            if (suggestQuery != '') result += '<p>' + this.getSettingValue('label.suggestion.suggestQuery').replace(/{{ terms }}/g, '<a href="' + this.buildSearchLink(suggestQuery) + '">' + suggestQuery + '</a>') + '</p>';
            if (dym != '') result += '<p>' + this.getSettingValue('label.suggestion.didYouMean').replace(/{{ terms }}/g, dym) + '</p>';
        }
    }
    return result;
};